enum Region {
  'EUROPE' = 'EUROPE',
  'NORTH_AMERICA' = 'NORTH_AMERICA',
  'AUSTRALIA' = 'AUSTRALIA',
  'CHINA' = 'CHINA',
  'OTHER' = 'OTHER',
}

export { Region }
